// Exports
export default {
	"oneColHeader": "oneColHeader_yHsj3",
	"title": "title_ynHoa",
	"listBox": "listBox_PBlsG"
};
